module.exports = __webpack_public_path__ + "roboto-latin-ext-300-italic.woff2";